<template>
  <div class="search-form">
    <b-row>
      <b-col>
        <span style="font-size: 18px; color: #2B3447;font-weight: 600">{{
          $l('title_customer_plan') || '客户计划'
        }}</span>
        <el-divider direction="vertical"></el-divider>
        <el-radio-group
          v-model="classification"
          size="small"
          @change="chagneType"
        >
          <el-radio-button label="C">{{
            $l('form_label_summary_by_warehouse') || '按仓库汇总'
          }}</el-radio-button>
          <el-radio-button label="R">{{
            $l('form_label_summarize_by_date') || '按日期汇总'
          }}</el-radio-button>
          <el-radio-button label="M">{{
            $l('form_label_display_by_details') || '按明细显示'
          }}</el-radio-button>
           <el-radio-button label="S">{{
            $l('form_label_display_by_shipping_date') || '按出货月汇总'
          }}</el-radio-button>
        </el-radio-group>
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-success"
          v-if="classification == 'C' && !disabled"
          @click="add()"
        >
          {{ $l('form_label_add_plan') || '添加计划' }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  classification: 'C',
}
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      form: { ...initForm },
      classification: 'C',
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    chagneType() {
      this.form.classification = this.classification
      this.$emit('query', this.form)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    add() {
      this.$emit('openEditPage', { type: 'add' })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
